import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts';
import axios from 'axios';
import router from './router/router'

let Event = new Vue();
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.Event = Event;
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.prototype.$baseURL = `${process.env.BASE_URL}`;
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
